type Queries = Record<string, string | number>

const routes = {
  featured_articles_path(queries: Queries = {}): string {
    return `/featured_articles${queryToParam(queries)}`
  },
  featured_article_path(id: number): string {
    return `/featured_articles/${id}`
  },
  log_featured_article_path(id: number): string {
    return `/featured_articles/${id}/log`
  },
  root_path: '/staff_admin/tokubai_featured_article',
  staff_admin_featured_articles_path(queries: Queries = {}): string {
    return `/staff_admin/tokubai_featured_article/featured_articles${queryToParam(queries)}`
  },
  staff_admin_featured_article_path(id: number): string {
    return `/staff_admin/tokubai_featured_article/featured_articles/${id}`
  },
  staff_admin_featured_article_content_path(id: number): string {
    return `/staff_admin/tokubai_featured_article/featured_articles/${id}/content`
  },
  staff_admin_featured_article_content_preview_path(id: number): string {
    return `/staff_admin/tokubai_featured_article/featured_articles/${id}/content/preview`
  },
  staff_admin_images_path(): string {
    return `/staff_admin/images`
  },
}

function queryToParam(queries: Queries = {}): string {
  if (queries.length === 0) {
    return ''
  } else {
    return `?${Object.entries(queries)
      .filter((query) => query[1])
      .map((query) => `${query[0]}=${query[1]}`)
      .join('&')}`
  }
}

export default routes
